export default __webpack_public_path__ + "static/media/profileimg.9b86a26d.png";